import AsszociaciosKerdesDto from 'app/admin/asszociacioskerdes/dto/AsszociaciosKerdesDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class AsszociaciosKerdesTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'asszociaciosLeirasTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, AsszociaciosKerdesDto)))
				.catch(reject);
		});
	}
}

export default new AsszociaciosKerdesTableService();
